import styled from 'styled-components';
import { device } from '../../../utils/responsive_utilities';
import { deepCoveDark, mintGreen, orange, white } from '../../loggedout/shared-styles/Colors';
import FontGraphie from '../../loggedout/shared-styles/graphieFont';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`

export const FormWrapper = styled.div`
  width: 36rem;
  margin: 7.2rem auto 0 auto; 
  text-align: left;
  @media ${device.Tablet}{
    margin: 9.6rem auto 0 auto;
  }
  @media ${device.PhoneTabletLandscape}{
    width: 30rem;
    margin: 3rem auto 0 auto;
  }

  @media ${device.Phone}{
    width: 90.7%;
    margin: 4.9rem auto 0 auto;
  }
`

export const PasswordElement = styled.div`
  margin-top: 1.6rem;
  @media ${device.PhoneTabletLandscape}{
    margin-top: 1rem;
  }
`
export const FormError = styled.div`
  padding-bottom: 1rem;
  text-align: center;
`

export const ErrorElement = styled.p`
  ${FontGraphie(1.2, 1.2, 5)}
  color: ${orange};
  padding: 0.5rem 0 0 2rem;
`
export const CTAElement = styled.div`
  margin-top: 5.2rem;

  @media ${device.TabletLandscape}{
    margin-top: 3.8rem;
  }
  @media ${device.Tablet}{
    margin-top: 11.2rem;
  }
  @media ${device.PhoneTabletLandscape}{
    margin-top: 1.6rem;
  }
  @media ${device.Phone}{
    margin-top: 4.6rem;
  }
`

export const SignupBtn = styled.button`
    width: 100%;
    height: 6rem;
    border-radius: 3rem;
    border: none;
    color: ${deepCoveDark};
    background-color: ${white};
    ${FontGraphie(2, 1.4, 6)}

    @media ${device.Tablet}{
      ${FontGraphie(1.8, 2, 6)}
    }
    @media ${device.PhoneTabletLandscape}{
      width: 30rem;
      height: 4rem;
      ${FontGraphie(1.6, 2, 6)}
    }
`

export const FormFooter = styled.div`
  margin-top: 1.6rem;
  color: ${white};
  padding-bottom: 0.7rem;
  ${FontGraphie(1.4, 1.4, 5)}
  > a{
    color: ${mintGreen};
    text-decoration: underline;
  }

  @media ${device.Tablet}, ${device.TabletLandscape}{
    margin-top: 2.9rem;
  }
  @media ${device.PhoneTabletLandscape}{
    margin-top:0.6rem;
    ${FontGraphie(1.1, 1, 4)}
  }
  @media ${device.Phone}{
    margin-top: 1.2rem;
    ${FontGraphie(1.1, 1, 4)}
  }
`

export const ImageWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  @media ${device.TabletLandscape}{
    display: block;
  }
  @media ${device.Tablet}, ${device.PhoneTabletLandscape}, ${device.Phone}{
    display: none;
  }
`